import { LCDClient } from "@terra-money/terra.js";
// older versions
export const terraClassic = new LCDClient({
    URL: "https://lcd.terra.dev",
    chainID: "columbus-5",
    isClassic: true,
  });